import { gql } from '@apollo/client'
import { DISPLAY_AUDIT_FRAGMENT } from '../fragments'

export const GET_DISPLAY_AUDITS = gql`
  query GetDisplayAudits($input: DisplayAuditsForDisplaysInput!) {
    displayAudits(input: $input) {
      hasMore
      count
      results {
        ...DisplayAudit
      }
    }
  }
  ${DISPLAY_AUDIT_FRAGMENT}
`
